import React, { useEffect, useRef, useState } from "react";
import "../styles/HomePageStyles/choice.css";
import milkshakes from "../assets/Choice/milkshake1.png";
import waffles from "../assets/Choice/waffesls2.png";
import falooda from "../assets/Choice/faloodaa3.png";
import rolledIcecream from "../assets/Choice/rolledIcecream.png";
import popping from "../assets/Choice/popping.png";
import icecreamimg from "../assets/Choice/icecream cake.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import Loader from "../utils/Loader";
import config from "../config";

const Choice = () => {
  // console.log("Choice Cat", categoryList)
  const [categoryList, setCategoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sliderData, setSliderData] = useState([]);

  const [slidIndex, setSlidIndex] = useState(0);

  const sliderRef = useRef();

  const settings = {
    dots: false,
    fade: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    autoplaySpeed: 2000,
    beforeChange: (current, next) => setSlidIndex(next),
    prevArrow: (
      <button className="custom-arrow slick-prev">
        <i className="bi bi-caret-left-fill"></i>{" "}
      </button>
    ), // Custom Previous Arrow
    nextArrow: (
      <button className="custom-arrow slick-next">
        <i className="bi bi-caret-right-fill"></i>{" "}
      </button>
    ), // Custom Next Arrow
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    gettingSliderData();
  }, []);

  const gettingSliderData = async () => {
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/homepage`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setSliderData(res.data?.second_slider);
        // console.log("Slider Data", res.data?.second_slider);
      });
    } catch (error) {
      console.log("eeor", error);
    }
  };

  return (
    <>
      {/* {isLoading && <Loader />} */}
      <div className="choice-container-wrapper">
        <div className="choice-container_top">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 100"
            fill="#ffdbe2"
          >
            <path d="M0 0v60c9 0 18-3 25-10 13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s37 13 50 0c14-14 37-14 50 0 7 7 16 10 25 10V0H0Z"></path>
          </svg>
        </div>

        <div className="container">
          <div className="choice_heading">
            <h2 data-aos="zoom-out">Our Sweet Creations</h2>
          </div>

          {/* <div className="choice-items"> */}
          <div className="choice-items">
            {/* Item 1 */}
            <Slider ref={sliderRef} {...settings}>
              {sliderData.map((item) => (
                <div className="choice_item_conta" key={item.id}>
                  {" "}
                  <div
                    className="choice_item choice_item_4"
                    data-aos="zoom-out"
                    key={item.id}
                  >
                    <div className="choice_item_img">
                      {/* <a href=""> */}
                      <img
                        src={item.image || "-"}
                        alt={item.slider_name || "-"}
                        className="img-fluid"
                      />
                      {/* </a> */}
                    </div>
                    <div className="choice_item_name">
                      <h4 style={{ wordBreak: "break-word" }}>
                        {item.slider_name || "-"}
                      </h4>
                    </div>
                    <div className="choice_item_disc">
                      <p>( Variety {item.variety || "-"} )</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        <div className="choice-container_bottom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 100"
            fill="#ffdbe2"
          >
            <path d="M0 0v60c9 0 18-3 25-10 13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s37 13 50 0c14-14 37-14 50 0 7 7 16 10 25 10V0H0Z"></path>
          </svg>
        </div>
      </div>
    </>
  );
};

export default Choice;
